import { Stack, Typography } from "@mui/material"

export const DadoValorPrinter = ({
    titulo,
    valor,
    alignValue = 'left',
    alignTitle = 'left',
}: DadoValorPrinterProps) => {
    return (
        <Stack>
            <Typography fontWeight="bold" variant="subtitle2" align={alignTitle}>{titulo}</Typography>
            <Typography variant="subtitle2" align={alignValue}>{valor}</Typography>
        </Stack>
    )
}

interface DadoValorPrinterProps {
    titulo: string,
    valor: string
    alignValue?: "right" | "left"
    alignTitle?: "right" | "left"
}

